import { z } from 'zod';
import { ApiMethod } from '../types/api.types';
import {
    clientSchema,
    detailedWorkspaceSchema,
    workspaceOptionsSchema,
    workspaceUpdateSchema
} from '../types/client.types';
import { workspaceParamsSchema } from '../types/payloads/workspace.payload';

export const API_ADMIN_WORKSPACE = {
    CREATE: {
        method: ApiMethod.POST,
        path: '/admin/workspaces',
        handlerMethod: 'createWorkspace',
        zod: {
            body: z.object({
                user: z.object({
                    email: z.string(),
                    firstname: z.string().optional(),
                    lastname: z.string().optional(),
                    locale: z.string().optional()
                }),
                workspace: workspaceOptionsSchema
            })
        },
        responses: {
            200: {
                description: 'Workspace created successfully',
                schema: clientSchema
            }
        }
    },
    GET: {
        method: ApiMethod.GET,
        path: '/admin/workspaces/:workspaceName',
        handlerMethod: 'getWorkspace',
        zod: {
            params: workspaceParamsSchema
        },
        responses: {
            200: {
                description: 'Workspace found successfully',
                schema: detailedWorkspaceSchema
            }
        }
    },
    PATCH: {
        method: ApiMethod.PATCH,
        path: '/admin/workspaces/:workspaceName',
        handlerMethod: 'patchWorkspace',
        zod: {
            params: workspaceParamsSchema,
            body: workspaceUpdateSchema
        },
        responses: {
            200: {
                description: 'Workspace updated successfully',
                schema: clientSchema
            }
        }
    }
} as const;
